// パスワード表示/非表示切り替え機能
document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.password-visibility-toggle');

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;
      const passwordInput = document.getElementById(targetId);
      const icon = button.querySelector('.material-symbols-outlined');

      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        icon.textContent = 'visibility_off';
        button.setAttribute('aria-label', 'パスワードを非表示にする');
      } else {
        passwordInput.type = 'password';
        icon.textContent = 'visibility';
        button.setAttribute('aria-label', 'パスワードを表示する');
      }
    });
  });
});
